import React from "react";

const providers = [
    "Pragmatic Play",
    "PG Soft",
    "Habanero",
    "Microgaming",
    "Spadegaming",
    "Joker Gaming",
    "Playtech",
    "CQ9",
    "SBOBET",
    "Evolution Gaming",
    "Yggdrasil",
    "Red Tiger",
];

export default function Providers() {
    const loop = [...providers, ...providers];
    return (
        <section
            id="provider"
            data-testid="providers-section"
            className="relative py-20 md:py-24 overflow-hidden border-y border-white/5 bg-[#080808]"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 text-center mb-10">
                <span className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
                    Mitra Resmi
                </span>
                <h2 className="mt-3 text-2xl md:text-4xl font-medium tracking-tight text-white">
                    Didukung provider{" "}
                    <span className="text-gold-gradient">kelas dunia</span>
                </h2>
            </div>

            <div
                className="relative flex overflow-hidden"
                aria-label="Daftar provider resmi PUSATCUAN"
            >
                <div className="flex whitespace-nowrap animate-marquee">
                    {loop.map((p, i) => (
                        <span
                            key={i}
                            data-testid={`provider-item-${i}`}
                            className="mx-10 text-3xl md:text-5xl font-semibold tracking-tight text-white/10 hover:text-[#D4AF37]/60 transition-colors"
                        >
                            {p}
                        </span>
                    ))}
                </div>
                <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#080808] to-transparent" />
                <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#080808] to-transparent" />
            </div>
        </section>
    );
}
